class LoyaltyTiers extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'content']
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }

    if (this?.els?.['add-birthday']?.exists) {
      this.handleAddBirthdayLink = this.handleAddBirthdayLink.bind(this)
      const addBirthdayEl = this.els['add-birthday'].element
      const link = addBirthdayEl.querySelector('a')
      if (link) {
        this.listeners.add(link, 'click', this.handleAddBirthdayLink)
      }
    }
  }

  handleTrigger (event) {
    const datasetId = event.target.closest(this.els.trigger.selector).dataset.id

    this.els.content.elements.forEach(contentEl => {
      contentEl.setAttribute(
        'aria-expanded',
        contentEl.dataset.id === datasetId,
      )
    })

    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.setAttribute('aria-pressed', triggerEl.dataset.id === datasetId)
    })
  }

  handleAddBirthdayLink (event) {
    event.preventDefault()
    const link = event.currentTarget
    window.dataLayer.push({
      event: 'loyaltyBirthdayLinkClicked',
    })
    window.location.href = link.href
  }
}

if (!customElements.get('loyalty-tiers')) {
  customElements.define('loyalty-tiers', LoyaltyTiers)
}
